import { store } from '@/store/store'
import Layout from '@/container/Full'
import { HostingAddons, HostingIpAddr } from '@/router/common'

// Main Cpanel components
const HostingGroupListView = () => import(/* webpackChunkName: "services" */ 'Views/services/hosting/HostingServiceView')
// const HostingCpanelView = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/CPanelView')

const HostingCpanelInfo = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/common/InfoView')
const HostingCpanelPassword = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/common/PasswordView')
const HostingCpanelAddons = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/common/AddonsView')
const HostingServiceAlerts = () => import(/* webpackChunkName: "services" */ '../views/services/alerts/AlertsServiceView')
const HostingCpanelLaunch = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/common/CpanelLaunchView')
// const HostingWordpress = () => import(/* webpackChunkName: "services" */ '../components/Services/Hosting/Shared/Wordpress')
// Mysql components
const HostingCpanelMysql = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/mysql/databases/MySqlView')
const HostingCpanelMysqlUsers = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/mysql/databases/MySqlUsersView')
const HostingCpanelMysqlRemote = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/mysql/databases/RemoteMySQLView')
// const HostingCpanelMysqlWizard = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/mysql/databases/MySQLWizardView')
const HostingPhpMyAdmin = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/mysql/databases/PhpMyAdminView')

// Email components
const HostingCpanelEmail = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/EmailAccountsView')
const HostingCpanelEmailForwarders = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/EmailForwardersView')
// const HostingCpanelEmailRouting = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/email/EmailRoutingView')
const HostingCpanelEmailAutoResponders = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/EmailRespondersView')
// const HostingCpanelEmailDefaultAddress = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/email/DefaultAddressView')
// const HostingCpanelEmailMailingList = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/email/MailingListView')
// const HostingCpanelEmailGlobalFilters = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/email/GlobalFiltersView')
const HostingCpanelEmailFilters = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/FiltersView')
const HostingCpanelEmailFiltersManage = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/FiltersManageView')
const HostingCpanelEmailAuthentication = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/AuthenticationView')
const HostingCpanelEmailAuthenticationManage = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/ManageAuthenticationView')
const HostingCpanelSpamFilters = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/email/SpamFiltersView')
// const HostingCpanelCalendars = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/email/CalendarsView')

// Security
const HostingSshAccess = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/security/SshAccessView')
const HostingManageSshKeys = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/security/ManageSshKeys')
// const HostingSslTls = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/security/SslTlsView')
// const HostingSslTlsCSRs = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/security/SslTlsCSRsView')
// const HostingSslTlsCertificates = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/security/SslTlsCertificatesView')
// const HostingSslTlsPrivateKeys = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/security/SslTlsPrivateKeysView')
const HostingBlockedIp = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/security/BlockedIp/BlockedIpView')
const SslManager = () => import(/* webpackChunkName: "services" */ '@/views/security/SslManager')
const ProtectedUrls = () => import(/* webpackChunkName: "services" */ '@/views/security/ProtectedUrls')

// Domains components
const HostingAddonDomains = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/AddonDomainsView')
const HostingSubdomains = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/SubdomainsView')
const HostingAliases = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/AliasesView')
const HostingRedirects = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/RedirectsView')
const HostingZoneEditor = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/ZoneEditorView')
const HostingChangePrimaryDomain = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/domains/ChangePrimaryDomainView')

// Advanced
const HostingCpanelCronJobs = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/advanced/CronJobsView')

// Ungrouped
const HostingCpanelFtpAccounts = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/files/FtpAccountsView')
// const HostingSiteBuilder = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/cpanel/common/SiteBuilderView')
const ServiceSingleView = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/ServiceSingleView')

// VDS/KVM (Virtual Dedicated Server) — structure mirrors shared hosting. Data comes
// from the Prox Customer API client in src/api/kvm.js (entitlement-scoped, per-service token).
const HostingKvmList = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmList')
const HostingKvmOrder = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmOrder')
const KvmServiceView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/KvmServiceView')
const HostingKvmInfo = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmInfo')
const HostingKvmIp = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmIp')
const HostingKvmSsh = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmSsh')
const HostingKvmRdns = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmRdns')
const HostingKvmConsole = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmConsole')
const HostingKvmTerminal = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmTerminal')
const HostingKvmRebuild = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmRebuild')
const HostingKvmGraphs = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmGraphs')
const HostingKvmAddons = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmAddons')
const HostingKvmFirewall = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmFirewall')
const HostingKvmDocker = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/kvm/HostingKvmDocker')

const HostingVServerInfo = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/vps/HostingVServerInfo')
const HostingVServerGraphs = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Common/ServerGraphs')
const HostingVServerReboot = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Common/ServerReboot')
const HostingVServerPassword = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Common/HostingVServerPassword')

const HostingWhmInfo = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/reseller/HostingWhmInfo')
const HostingWhmListAccounts = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/reseller/HostingWhmListAccounts')
const HostingWhmPassword = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/reseller/HostingWhmPassword')
const HostingSiteBuilder = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Common/HostingSiteBuilder')
// const HostingCpanelLaunch = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Common/HostingCpanelLaunch')

const HostingDserverInfo = () => import(/* webpackChunkName: "services" */ 'Components/Services/Hosting/Common/ServiceInfo')
const HostingDserverAddress = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/common/HostingIpAddr')
const HostingDserverReboot = () => import(/* webpackChunkName: "services" */ '../components/Services/Hosting/Common/ServerReboot')
const HostingDserverGraphs = () => import(/* webpackChunkName: "services" */ '../components/Services/Hosting/Common/ServerGraphs')
const HostingDserverPassword = () => import(/* webpackChunkName: "services" */ '@/components/Services/Hosting/Dedicated/DServerPassword')
const HostingDserverAddons = () => import(/* webpackChunkName: "services" */ '../components/Services/Hosting/Common/HostingAddons')
const HostingDserverWHM = () => import(/* webpackChunkName: "services" */ '../components/Services/Hosting/Dedicated/DServerWHM')

// const HostingAlerts = () => import(/* webpackChunkName: "services" */ '../views/services/alerts/AlertsView')

// Stats
const HostingErrorLogs = () => import(/* webpackChunkName: "services" */ '../views/services/hosting/shared/stats/logs/ErrorLogs')
const VisitorsView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/stats/metrics/VisitorsView')

// Software
const PhpManagerView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/php/PhpManagerView')

// Files
const GitView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/git/GitView')

// WordPress
const HostingWordpressView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/wordpress/WordpressView')
const InstallAndManageView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/wordpress/InstallAndManageView')
const StagingView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/wordpress/staging/StagingView')
const AutoupdateView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/wordpress/AutoupdateView')
// const ApiTest = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/wordpress/ApiTest')

const CreateRequest = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/updowngrade/CreateRequest')
const ViewRequest = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/shared/updowngrade/RequestView')
const HostingWhmAccountAdd = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/reseller/HostingWhmAccountAdd')
const HostingWhmPackages = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/reseller/HostingWhmPackages')
const AppInstallerView = () => import(/* webpackChunkName: "services" */ '@/views/services/hosting/common/AppInstaller')

const SslOverview = () => import(/* webpackChunkName: "services" */ '@/views/security/SslOverview')
const SslCreateView = () => import(/* webpackChunkName: "services" */ '@/views/security/SslCreate')

const routes = [
  {
    path: '/hosting',
    component: Layout,
    children: [
      {
        path: '',
        name: 'hosting_services',
        component: HostingGroupListView,
        meta: {
          breadcrumb: 'My Hosting Accounts',
          pageTitle: 'My Hosting Plans',
          access_type: 'authorized'
        },
        children: [
          {
            path: '/hosting/shared/:hostingid',
            component: ServiceSingleView,
            props: true,
            meta: {
              breadcrumb: () => store.getters.hosting.domain,
              access_type: 'authorized',
              parent: 'hosting_services'
            },
            children: [
              // Main
              {
                path: '',
                component: HostingCpanelInfo,
                name: 'hosting_cpanel_info',
                props: true,
                meta: {
                  breadcrumb: 'Account info',
                  pageTitle: 'Panel',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'Account Information',
                }
              },
              {
                path: 'protected-urls',
                name: 'protected_urls',
                component: ProtectedUrls,
                meta: {
                  breadcrumb: 'Protected URLs',
                  pageTitle: 'Protected URLs',
                  pageSubtitle: 'Protected URLs',
                  access_type: 'authorized'
                },
              },
              {
                path: 'ssl',
                name: 'hosting_ssl',
                component: SslManager,
                meta: {
                  breadcrumb: 'SSL Manager',
                  pageTitle: 'SSL Manager',
                  pageSubtitle: 'SSL Manager',
                  access_type: 'authorized'
                },
              },
              {
                path: 'ssl/create',
                name: 'hosting_ssl_create',
                component: SslCreateView,
                props: true,
                meta: {
                  breadcrumb: 'Upgrade SSL Certificate',
                  pageTitle: 'Upgrade SSL Certificate',
                  pageSubtitle: 'Upgrade SSL Certificate',
                  access_type: 'authorized'
                },
              },
              {
                path: 'ssl/:id',
                name: 'hosting_ssl_manage',
                component: SslOverview,
                props: true,
                meta: {
                  breadcrumb: 'Manage SSL',
                  pageTitle: 'Manage SSL',
                  pageSubtitle: 'Manage SSL',
                  access_type: 'authorized'
                },
              },
              {
                path: 'wordpress',
                component: HostingWordpressView,
                name: 'hosting_wordpress',
                props: true,
                meta: {
                  breadcrumb: 'WordPress',
                  pageTitle: 'WordPress',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'WordPress',
                },
                children: [
                  {
                    path: 'install-and-manage',
                    component: InstallAndManageView,
                    name: 'hosting_wp_manage',
                    props: true,
                    meta: {
                      breadcrumb: 'Install And Manage',
                      pageTitle: 'WordPress: Install & Manage',
                      access_type: 'authorized',
                      pageSubtitle: 'WordPress: Install & Manage',
                    }
                  },
                  {
                    path: 'staging',
                    component: StagingView,
                    name: 'hosting_wp_staging',
                    props: true,
                    meta: {
                      breadcrumb: 'Staging',
                      pageTitle: 'Staging',
                      access_type: 'authorized',
                      pageSubtitle: 'Staging',
                    }
                  },
                  {
                    path: 'autoupdate',
                    component: AutoupdateView,
                    name: 'hosting_wp_autoupdate',
                    props: true,
                    meta: {
                      breadcrumb: 'Autoupdate',
                      pageTitle: 'Autoupdate',
                      access_type: 'authorized',
                      pageSubtitle: 'Autoupdate',
                    }
                  },
                  // page for testing softaculous API
                  // {
                  //   path: 'api-test',
                  //   component: ApiTest,
                  //   name: 'hosting_wp_api_test',
                  //   props: true,
                  //   meta: {
                  //     breadcrumb: 'API Test',
                  //     pageTitle: 'API Test',
                  //     access_type: 'authorized',
                  //     pageSubtitle: 'API Test',
                  //   }
                  // },
                ]
              },
              {
                path: 'app-installer',
                component: AppInstallerView,
                name: 'hosting_app_installer',
                props: true,
                meta: {
                  breadcrumb: 'App Installer',
                  pageTitle: 'App Installer',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'App Installer',
                }
              },
              {
                path: 'sitebuilder',
                component: HostingSiteBuilder,
                name: 'hosting_sitebuilder',
                props: true,
                meta: {
                  breadcrumb: 'Site Builder',
                  pageTitle: 'Shared Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'Site Builder',
                }
              },
              {
                path: 'password',
                component: HostingCpanelPassword,
                name: 'hosting_cpanel_password',
                props: true,
                meta: {
                  breadcrumb: 'Password Management',
                  pageTitle: 'Shared Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'Change Password',
                }
              },
              {
                path: 'addons',
                component: HostingCpanelAddons,
                name: 'hosting_addons',
                props: true,
                meta: {
                  breadcrumb: 'Add-ons',
                  pageTitle: 'Shared Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'Service Add-ons',
                }
              },
              {
                path: 'alerts',
                component: HostingServiceAlerts,
                name: 'hosting_service_alerts',
                props: true,
                meta: {
                  breadcrumb: 'Service Alerts',
                  pageTitle: 'Service Alerts',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                  pageSubtitle: 'Service Alerts',
                }
              },
              {
                path: 'cpanel',
                component: HostingCpanelLaunch,
                name: 'hosting_cpanel_launch',
                props: true,
                meta: {
                  breadcrumb: 'Launch cPanel',
                  pageTitle: 'Shared Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_services',
                }
              },
              // Email
              {
                path: 'email-accounts',
                component: HostingCpanelEmail,
                name: 'email-accounts',
                props: true,
                meta: {
                  breadcrumb: 'Email accounts',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Accounts',
                  access_type: 'authorized'
                }
              },
              {
                path: 'email-forwarders',
                component: HostingCpanelEmailForwarders,
                name: 'hosting_email_forwarders',
                props: true,
                meta: {
                  breadcrumb: 'Forwarders',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Forwarders',
                  access_type: 'authorized'
                }
              },
              // {
              //   path: 'email-routing',
              //   component: HostingCpanelEmailRouting,
              //   name: 'hosting_email_routing',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'Email routing',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              {
                path: 'email-autoresponders',
                component: HostingCpanelEmailAutoResponders,
                name: 'hosting_email_autoresponders',
                props: true,
                meta: {
                  breadcrumb: 'Email autoresponders',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Autoresponders',
                  access_type: 'authorized'
                }
              },
              // {
              //   path: 'email-default-address',
              //   component: HostingCpanelEmailDefaultAddress,
              //   name: 'hosting_email_default_address',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'Default address',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              // {
              //   path: 'email-mailing-list',
              //   component: HostingCpanelEmailMailingList,
              //   name: 'hosting_email_mailing_list',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'Mailing list',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              // {
              //   path: 'email-global-filters',
              //   component: HostingCpanelEmailGlobalFilters,
              //   name: 'hosting_email_global_filters',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'Email global filters',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              {
                path: 'email-filters',
                component: HostingCpanelEmailFilters,
                name: 'hosting_email_filters',
                props: true,
                meta: {
                  breadcrumb: 'Email filters',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Filters',
                  access_type: 'authorized'
                },
                children: [
                  {
                    path: 'manage',
                    component: HostingCpanelEmailFiltersManage,
                    name: 'hosting_email_filters_manage',
                    props: true,
                    meta: {
                      breadcrumb: 'Manage',
                      pageTitle: 'Shared Hosting',
                      pageSubtitle: 'Email Spam Filters',
                      access_type: 'authorized'
                    },
                  }
                ],
              },
              {
                path: 'authentication',
                component: HostingCpanelEmailAuthentication,
                name: 'hosting_email_authentication',
                props: true,
                meta: {
                  breadcrumb: 'Authentication',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Deliverability',
                  access_type: 'authorized'
                },
              },
              {
                path: 'authentication/:domain',
                component: HostingCpanelEmailAuthenticationManage,
                name: 'hosting_email_authentication_manage',
                meta: {
                  breadcrumb: 'Authentication',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Email Deliverability',
                  access_type: 'authorized'
                },
              },
              // {
              //   path: 'calendars',
              //   component: HostingCpanelCalendars,
              //   name: 'hosting_email_calendars_contacts',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'Calendars & Contacts',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              {
                path: 'spam-filters',
                component: HostingCpanelSpamFilters,
                name: 'hosting_spam_filters',
                props: true,
                meta: {
                  breadcrumb: 'Apache SpamAssasin',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Setup Spam Filters',
                  access_type: 'authorized'
                },
              },
              {
                path: 'mysql',
                component: HostingCpanelMysql,
                name: 'hosting_cpanel_mysql',
                props: true,
                meta: {
                  breadcrumb: 'MySQL® Databases',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'MySQL Databases',
                  access_type: 'authorized'
                }
              },
              {
                path: 'mysql-users',
                component: HostingCpanelMysqlUsers,
                name: 'hosting_mysql_users',
                props: true,
                meta: {
                  breadcrumb: 'MySQL® Users',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'MySQL Users',
                  access_type: 'authorized'
                }
              },
              {
                path: 'remote-mysql',
                component: HostingCpanelMysqlRemote,
                name: 'hosting_cpanel_mysql_remote',
                props: true,
                meta: {
                  breadcrumb: 'Remote MySQL®',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Remote MySQL®',
                  access_type: 'authorized'
                }
              },
              // {
              //   path: 'mysql-database-wizard',
              //   component: HostingCpanelMysqlWizard,
              //   name: 'hosting_cpanel_mysql_wizard',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'MySQL® Database Wizzard',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   }
              // },
              {
                path: 'phpmyadmin',
                component: HostingPhpMyAdmin,
                name: 'hosting_cpanel_php_my_admin',
                props: true,
                meta: {
                  breadcrumb: 'phpMyAdmin',
                  pageTitle: 'phpMyAdmin',
                  pageSubtitle: 'phpMyAdmin',
                  access_type: 'authorized'
                }
              },
              // Security
              {
                path: 'manage-ssh',
                component: HostingSshAccess,
                name: 'hosting_cpanel_manage_ssh',
                props: true,
                meta: {
                  breadcrumb: 'SHH keys',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'SSH Manager',
                  access_type: 'authorized'
                },
                children: [
                  {
                    path: 'keys',
                    component: HostingManageSshKeys,
                    name: 'hosting_cpanel_ssh_keys',
                    props: true,
                    meta: {
                      pageTitle: 'Shared Hosting',
                      access_type: 'authorized'
                    }
                  },
                ],
              },
              // {
              //   path: 'ssl-tls',
              //   component: HostingSslTls,
              //   name: 'hosting_cpanel_ssl_tls',
              //   props: true,
              //   meta: {
              //     breadcrumb: 'SSL/TLS',
              //     pageTitle: 'Shared Hosting',
              //     access_type: 'authorized'
              //   },
              //   children: [
              //     {
              //       path: 'private-keys',
              //       component: HostingSslTlsPrivateKeys,
              //       name: 'hosting_cpanel_ssl_tls_private_keys',
              //       props: true,
              //       meta: {
              //         breadcrumb: 'Private keys',
              //         pageTitle: 'Shared Hosting',
              //         access_type: 'authorized'
              //       }
              //     },
              //     {
              //       path: 'csrs',
              //       component: HostingSslTlsCSRs,
              //       name: 'hosting_cpanel_ssl_tls_csrs',
              //       props: true,
              //       meta: {
              //         breadcrumb: 'Certificate signing requests',
              //         pageTitle: 'Shared Hosting',
              //         access_type: 'authorized'
              //       }
              //     },
              //     {
              //       path: 'certificates',
              //       component: HostingSslTlsCertificates,
              //       name: 'hosting_cpanel_ssl_tls_certificates',
              //       props: true,
              //       meta: {
              //         breadcrumb: 'Certificates',
              //         pageTitle: 'Shared Hosting',
              //         access_type: 'authorized'
              //       }
              //     },
              //   ],
              // },
              // HostingBlockedIp
              {
                path: 'blocked-ip',
                component: HostingBlockedIp,
                name: 'hosting_cpanel_blocked_ip',
                props: true,
                meta: {
                  breadcrumb: 'Blocked IP',
                  pageTitle: 'Shared Hosting',
                  access_type: 'authorized'
                },
              },
              // Domains
              {
                path: 'addon-domains',
                component: HostingAddonDomains,
                name: 'hosting_cpanel_addon_domains',
                props: true,
                meta: {
                  breadcrumb: 'Addon domains',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Addon Domains',
                  access_type: 'authorized'
                }
              },
              {
                path: 'subdomains',
                component: HostingSubdomains,
                name: 'hosting_cpanel_subdomains',
                props: true,
                meta: {
                  breadcrumb: 'Subdomains',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Subdomains',
                  access_type: 'authorized'
                }
              },
              {
                path: 'parked-domains',
                component: HostingAliases,
                name: 'hosting_parked_domains',
                props: true,
                meta: {
                  breadcrumb: 'Parked Domains',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Parked Domains',
                  access_type: 'authorized'
                }
              },
              {
                path: 'redirects',
                component: HostingRedirects,
                name: 'hosting_cpanel_redirects',
                props: true,
                meta: {
                  breadcrumb: 'Redirects',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Redirects',
                  access_type: 'authorized'
                }
              },
              {
                path: 'zone-editor',
                component: HostingZoneEditor,
                name: 'hosting_cpanel_zone_editor',
                props: true,
                meta: {
                  breadcrumb: 'Zone editor',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Zone Editor',
                  access_type: 'authorized'
                }
              },
              {
                path: 'change-primary-domain',
                component: HostingChangePrimaryDomain,
                name: 'hosting_cpanel_change_primary_domain',
                props: true,
                meta: {
                  breadcrumb: 'Change Primary Domain',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Change Primary Domain',
                  access_type: 'authorized'
                }
              },
              // Advanced
              {
                path: 'cron-jobs',
                component: HostingCpanelCronJobs,
                name: 'hosting_cpanel_cron_jobs',
                props: true,
                meta: {
                  breadcrumb: 'Cron Jobs',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Cron Jobs',
                  access_type: 'authorized'
                }
              },
              // Files
              {
                path: 'ftp-accounts',
                component: HostingCpanelFtpAccounts,
                name: 'hosting_cpanel_ftp_accounts',
                props: true,
                meta: {
                  breadcrumb: 'FTP Accounts',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'FTP Accounts',
                  access_type: 'authorized'
                }
              },
              {
                path: 'error-log',
                component: HostingErrorLogs,
                name: 'hosting_cpanel_error_log',
                props: true,
                meta: {
                  breadcrumb: 'Errors',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Errors',
                  access_type: 'authorized'
                }
              },
              {
                path: 'visitors',
                component: VisitorsView,
                name: 'hosting_cpanel_visitors',
                props: true,
                meta: {
                  breadcrumb: 'Visitors',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Visitors',
                  access_type: 'authorized'
                }
              },
              {
                path: 'php-manager',
                component: PhpManagerView,
                name: 'hosting_php_manager',
                props: true,
                meta: {
                  breadcrumb: 'PHP Manager',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'PHP Manager',
                  access_type: 'authorized'
                }
              },
              {
                path: 'git',
                component: GitView,
                name: 'hosting_git',
                props: true,
                meta: {
                  breadcrumb: 'Git Version Control',
                  pageTitle: 'Shared Hosting',
                  pageSubtitle: 'Git Manager',
                  access_type: 'authorized'
                }
              },
              {
                path: 'request-upgrade/:path?',
                component: CreateRequest,
                name: 'hosting_create_request',
                props: true,
                meta: {
                  breadcrumb: 'Change Plan',
                  access_type: 'authorized',
                  pageSubtitle: () => 'Select a New Plan for ' + store.getters.hosting.domain,
                  hideNavigation: true
                }
              },
              {
                path: 'request-view/:id',
                component: ViewRequest,
                name: 'hosting_view_request',
                props: true,
                meta: {
                  breadcrumb: 'Change Plan',
                  access_type: 'authorized',
                  hideNavigation: true,
                  pageSubtitle: 'Plan Change Status',
                }
              },
            ],
          },
          {
            path: '/hosting/reseller/:hostingid',
            component: ServiceSingleView,
            props: true,
            meta: {
              breadcrumb: () => store.getters.hosting.domain,
              pageTitle: 'Reseller Hosting',
              access_type: 'authorized',
              parent: 'hosting_reseller'
            },
            children: [
              {
                path: '',
                component: HostingWhmInfo,
                name: 'hosting_whm_info',
                props: true,
                meta: {
                  breadcrumb: 'Account Info',
                  pageSubtitle: 'Overview',
                  pageTitle: 'Panel',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'list-accounts',
                component: HostingWhmListAccounts,
                name: 'hosting_whm_list_accounts',
                props: true,
                meta: {
                  breadcrumb: 'Accounts List',
                  pageSubtitle: 'Reseller: List Accounts',
                  pageTitle: 'Reseller Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'sitebuilder',
                component: HostingSiteBuilder,
                name: 'hosting_whm_sitebuilder',
                props: true,
                meta: {
                  breadcrumb: 'Sitebuilder',
                  pageSubtitle: 'Site Builder',
                  pageTitle: 'Reseller Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'password',
                component: HostingWhmPassword,
                name: 'hosting_whm_password',
                props: true,
                meta: {
                  breadcrumb: 'Password management',
                  pageSubtitle: 'Change Password',
                  pageTitle: 'Reseller Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'cpanel',
                component: HostingCpanelLaunch,
                name: 'hosting_whm_cpanel_launch',
                props: true,
                meta: {
                  breadcrumb: 'cPanel launch',
                  pageTitle: 'Reseller Hosting',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'addons',
                component: HostingAddons,
                name: 'hosting_whm_addons',
                props: true,
                meta: {
                  breadcrumb: 'Addons',
                  pageTitle: 'Reseller Hosting',
                  pageSubtitle: 'Service Add-ons',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'accounts/add',
                component: HostingWhmAccountAdd,
                name: 'hosting_whm_account_add',
                props: true,
                meta: {
                  breadcrumb: 'Account',
                  pageTitle: 'Create Account',
                  pageSubtitle: 'Create Account',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'packages',
                component: HostingWhmPackages,
                name: 'hosting_whm_packages',
                props: true,
                meta: {
                  breadcrumb: 'Packages',
                  pageTitle: 'Package Management',
                  pageSubtitle: 'Package Management',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                },
              },
              {
                path: 'zone-editor',
                component: HostingZoneEditor,
                name: 'hosting_whm_zone_editor',
                props: true,
                meta: {
                  breadcrumb: 'Zone editor',
                  pageTitle: 'Reseller Hosting',
                  pageSubtitle: 'Zone Editor',
                  access_type: 'authorized',
                  parent: 'hosting_reseller'
                }
              },
            ]
          },
          {
            // The existing VPS product, listed with the KVM servers at /servers.
            path: '/servers/mvm/:hostingid',
            component: ServiceSingleView,
            props: true,
            meta: {
              breadcrumb: () => store.getters.hosting.domain,
              pageTitle: 'Virtual Private Server',
              access_type: 'authorized',
              parent: 'hosting_vps'
            },
            children: [
              {
                path: '',
                component: HostingVServerInfo,
                name: 'hosting_vserver_info',
                props: true,
                meta: {
                  breadcrumb: 'Account Info',
                  pageTitle: 'Panel',
                  pageSubtitle: 'Account Information',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
              {
                path: 'address',
                component: HostingIpAddr,
                name: 'hosting_vserver_address',
                meta: {
                  breadcrumb: 'IP Management',
                  pageTitle: 'Virtual Private Server',
                  pageSubtitle: 'IP Management',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
              {
                path: 'password',
                component: HostingVServerPassword,
                name: 'hosting_vserver_password',
                props: true,
                meta: {
                  breadcrumb: 'Password management',
                  pageTitle: 'Virtual Private Server',
                  pageSubtitle: 'Change Password',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
              {
                path: 'addons',
                component: HostingAddons,
                name: 'hosting_vserver_addons',
                props: true,
                meta: {
                  breadcrumb: 'Addons',
                  pageTitle: 'Virtual Private Server',
                  pageSubtitle: 'Service Add-ons',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
              {
                path: 'graphs',
                component: HostingVServerGraphs,
                name: 'hosting_vserver_graphs',
                props: true,
                meta: {
                  breadcrumb: 'Server graphs',
                  pageTitle: 'Virtual Private Server',
                  pageSubtitle: 'Server Graphs',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
              {
                path: 'reboot',
                component: HostingVServerReboot,
                name: 'hosting_vserver_reboot',
                props: true,
                meta: {
                  breadcrumb: 'Reboot',
                  pageTitle: 'Virtual Private Server',
                  pageSubtitle: 'Reboot Management',
                  access_type: 'authorized',
                  parent: 'hosting_vps'
                },
              },
            ]
          },
          {
            path: '/hosting/dedicated/:hostingid',
            component: ServiceSingleView,
            props: true,
            meta: {
              breadcrumb: () => store.getters.hosting.domain,
              pageTitle: 'Dedicated Server',
              access_type: 'authorized',
              parent: 'hosting_dedicated'
            },
            children: [
              {
                path: '',
                name: 'hosting_dserver_info',
                component: HostingDserverInfo,
                props: true,
                meta: {
                  breadcrumb: 'Domain Info',
                  pageSubtitle: 'Domain Information',
                  pageTitle: 'Panel',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'address',
                name: 'hosting_dserver_address',
                component: HostingDserverAddress,
                props: true,
                meta: {
                  breadcrumb: 'IP Management',
                  pageTitle: 'Dedicated Server',
                  pageSubtitle: 'IP Management',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'reboot',
                name: 'hosting_dserver_reboot',
                component: HostingDserverReboot,
                props: true,
                meta: {
                  breadcrumb: 'Reboot',
                  pageSubtitle: 'Reboot Server',
                  pageTitle: 'Dedicated Server',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'graphs',
                name: 'hosting_dserver_graphs',
                component: HostingDserverGraphs,
                props: true,
                meta: {
                  breadcrumb: 'Server graphs',
                  pageSubtitle: 'Dedicated Server Graphs',
                  pageTitle: 'Dedicated Server',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'password',
                name: 'hosting_dserver_password',
                component: HostingDserverPassword,
                props: true,
                meta: {
                  breadcrumb: 'Password management',
                  pageSubtitle: 'Change Password',
                  pageTitle: 'Dedicated Server',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'addons',
                name: 'hosting_dserver_addons',
                component: HostingDserverAddons,
                props: true,
                meta: {
                  breadcrumb: 'Add-ons',
                  pageSubtitle: 'Service Add-ons',
                  pageTitle: 'Dedicated Server',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              },
              {
                path: 'whm',
                name: 'hosting_dserver_whm',
                component: HostingDserverWHM,
                props: true,
                meta: {
                  breadcrumb: 'WHM launch',
                  pageTitle: 'Dedicated Server',
                  access_type: 'authorized',
                  parent: 'hosting_dedicated'
                },
              }
            ]
          }
        ]
      },
    ],
  },

  // Old server URLs → the /servers ones, so bookmarks and emailed links keep working.
  { path: '/hosting/kvm', redirect: '/servers' },
  { path: '/hosting/kvm/order', redirect: '/servers/order' },
  { path: '/hosting/kvm/:hostingid', redirect: to => `/servers/vps/${to.params.hostingid}` },
  { path: '/hosting/kvm/:hostingid/*', redirect: to => `/servers/vps/${to.params.hostingid}/${to.params.pathMatch}` },
  { path: '/hosting/vps/:hostingid', redirect: to => `/servers/mvm/${to.params.hostingid}` },
  { path: '/hosting/vps/:hostingid/*', redirect: to => `/servers/mvm/${to.params.hostingid}/${to.params.pathMatch}` },

  // Servers: one list of all the account's servers at /servers — the KVM product
  // at /servers/vps/:id, the existing VPS product at /servers/mvm/:id (defined with
  // the other billing-service types above, under ServiceSingleView).
  //
  // KVM mirrors the shared-hosting structure: ServiceSidebar (left nav) is driven
  // by kvmMenu, and KvmServiceView renders the title + the section <router-view>.
  // Standalone (not under ServiceSingleView) because it is entitlement-scoped via
  // the Prox Customer API (src/api/kvm.js), not the billing-service tree.
  {
    path: '/servers',
    component: Layout,
    children: [
      {
        path: '',
        name: 'hosting_kvm_list',
        component: HostingKvmList,
        meta: {
          breadcrumb: 'Servers',
          pageTitle: 'Servers',
          access_type: 'authorized',
        },
      },
      {
        path: 'order',
        name: 'hosting_kvm_order',
        component: HostingKvmOrder,
        meta: {
          breadcrumb: 'Add a Server',
          pageTitle: 'Add a Server',
          access_type: 'authorized',
        },
      },
      {
        path: 'vps/:hostingid',
        component: KvmServiceView,
        props: true,
        meta: {
          breadcrumb: 'Virtual Dedicated Server',
          pageTitle: 'Virtual Dedicated Server',
          access_type: 'authorized',
          parent: 'hosting_kvm_list',
        },
        children: [
          {
            path: '',
            name: 'hosting_kvm_info',
            component: HostingKvmInfo,
            props: true,
            meta: { breadcrumb: 'Overview', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Overview', access_type: 'authorized' },
          },
          {
            path: 'ip',
            name: 'hosting_kvm_ip',
            component: HostingKvmIp,
            props: true,
            meta: { breadcrumb: 'IP Addresses', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'IP Addresses', access_type: 'authorized' },
          },
          {
            path: 'ssh-keys',
            name: 'hosting_kvm_ssh',
            component: HostingKvmSsh,
            props: true,
            meta: { breadcrumb: 'SSH Keys', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'SSH Keys', access_type: 'authorized' },
          },
          {
            path: 'firewall',
            name: 'hosting_kvm_firewall',
            component: HostingKvmFirewall,
            props: true,
            meta: { breadcrumb: 'Firewall', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Firewall', access_type: 'authorized' },
          },
          {
            // Docker Manager — sidebar item shown only when the service has
            // docker_enabled (kvmFeatures); the page itself also guards on it.
            path: 'docker',
            name: 'hosting_kvm_docker',
            component: HostingKvmDocker,
            props: true,
            meta: { breadcrumb: 'Docker', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Docker', access_type: 'authorized' },
          },
          {
            path: 'rdns',
            name: 'hosting_kvm_rdns',
            component: HostingKvmRdns,
            props: true,
            meta: { breadcrumb: 'Reverse DNS', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Reverse DNS', access_type: 'authorized' },
          },
          {
            path: 'terminal',
            name: 'hosting_kvm_terminal',
            component: HostingKvmTerminal,
            props: true,
            meta: { breadcrumb: 'Terminal', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Terminal', access_type: 'authorized' },
          },
          {
            path: 'console',
            name: 'hosting_kvm_console',
            component: HostingKvmConsole,
            props: true,
            meta: { breadcrumb: 'Console', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Console (VNC)', access_type: 'authorized' },
          },
          {
            path: 'rebuild',
            name: 'hosting_kvm_rebuild',
            component: HostingKvmRebuild,
            props: true,
            meta: { breadcrumb: 'Rebuild', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Rebuild', access_type: 'authorized' },
          },
          {
            path: 'graphs',
            name: 'hosting_kvm_graphs',
            component: HostingKvmGraphs,
            props: true,
            meta: { breadcrumb: 'Graphs', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Graphs', access_type: 'authorized' },
          },
          {
            path: 'addons',
            name: 'hosting_kvm_addons',
            component: HostingKvmAddons,
            props: true,
            meta: { breadcrumb: 'Add-ons', pageTitle: 'Virtual Dedicated Server', pageSubtitle: 'Add-ons', access_type: 'authorized' },
          },
        ],
      },
    ],
  },

  // {
  //   path: '/alerts',
  //   component: Layout,
  //   children: [
  //     {
  //       path: '',
  //       name: 'hosting_alerts',
  //       component: HostingAlerts,
  //       meta: {
  //         access_type: 'authorized',
  //       },
  //     }
  //   ],
  // },
]

export default routes
